import { render, staticRenderFns } from "./add-design-works.vue?vue&type=template&id=20c7f0ca&"
import script from "./add-design-works.vue?vue&type=script&lang=ts&"
export * from "./add-design-works.vue?vue&type=script&lang=ts&"
import style0 from "./add-design-works.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./add-design-works.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports